import React from 'react';
import styled from 'styled-components';
import { Checkbox } from 'antd';
import { width } from 'styled-system';

const StyledCheckbox = styled(Checkbox).attrs(({ label, children }) => ({ children: label || children }))`
  align-items: center !important;
  ${width};

  .ant-checkbox {
    top: 0;
  }
`;

export default StyledCheckbox;
